import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import cn from 'classnames';
import FooterBody from './FooterBody';
import FooterBottom from './FooterBottom';
import routes from '../../routes/constants';
import { isRouteIncluded } from '../../utilities/routes';
import useBreakpoint from '../../hooks/useBreakpoint';
var ROUTES_ALLOWED = [
    routes.dashboard,
    routes.user.profile
];
var isVisibleForRoute = function(r) {
    return isRouteIncluded(ROUTES_ALLOWED)(r);
};
var Footer = function() {
    var location = useLocation();
    var isEnabledForBkpt = useBreakpoint([
        'xs',
        'sm',
        'md'
    ]);
    var userDetailsState = useSelector(function(state) {
        return state.profileReducer.userProfile;
    });
    var isVisible = isVisibleForRoute(location.pathname) && isEnabledForBkpt;
    return (isEmpty(userDetailsState) || isVisible) && /*#__PURE__*/ React.createElement("footer", {
        id: "Footer",
        className: cn({
            'only-bottom': isVisible
        })
    }, /*#__PURE__*/ React.createElement(FooterBody, null), /*#__PURE__*/ React.createElement(FooterBottom, null));
};
export default Footer;
